import { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ExternalLink, Phone } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
import { useBookingLinks } from "../context/BookingLinksContext";

const BirthdayPartiesPage = () => {
  const [parties, setParties] = useState([]);
  const bookingLinks = useBookingLinks();

  useEffect(() => {
    const fetchParties = async () => {
      try {
        const res = await axios.get(`${API}/birthday-parties`);
        setParties(res.data);
      } catch {
        setParties([]);
      }
    };
    fetchParties();
  }, []);

  const colors = ["#ff3131", "#7dbff8", "#ff3131", "#7dbff8"];

  return (
    <div className="min-h-screen" data-testid="birthday-page">
      <Header />
      
      <main>
        {/* Hero */}
        <section className="py-12 md:py-16 bg-gradient-to-b from-[#fff5f5] to-[#FFFBF5]">
          <div className="container-gymtots text-center">
            <h1 
              className="text-3xl md:text-4xl font-bold text-[#2D3436] mb-4"
              style={{ fontFamily: 'Fredoka, cursive' }}
            >
              Birthday <span className="text-[#ff3131]">Parties</span>
            </h1>
            <p className="text-[#636E72] max-w-xl mx-auto">
              Give your little one the ultimate gymnastics birthday party!
            </p>
          </div>
        </section>

        {/* Party Packages */}
        <section className="py-12 md:py-16 bg-white">
          <div className="container-gymtots">
            <div className={`grid gap-6 max-w-4xl mx-auto ${parties.length >= 3 ? 'md:grid-cols-3' : parties.length === 2 ? 'md:grid-cols-2' : 'max-w-md'}`}>
              {parties.map((party, i) => {
                const color = colors[i % colors.length];
                return (
                  <div 
                    key={party.id || i}
                    className="bg-white rounded-2xl overflow-hidden border-2 border-gray-100 hover:shadow-lg transition-shadow"
                    data-testid={`party-card-${party.id || i}`}
                  >
                    {/* Header */}
                    <div className="px-6 py-4" style={{ backgroundColor: color }}>
                      <h3 className="text-white font-bold text-xl text-center" style={{ fontFamily: 'Fredoka, cursive' }}>
                        {party.name}
                      </h3>
                    </div>

                    <div className="p-6">
                      {/* Pricing */}
                      <div className="space-y-3 mb-6">
                        <div className="flex items-center justify-between bg-[#FFFBF5] rounded-xl p-3">
                          <span className="text-sm font-semibold text-[#2D3436]">Members</span>
                          <span className="text-lg font-bold" style={{ fontFamily: 'Fredoka, cursive', color }}>{party.member_price}</span>
                        </div>
                        <div className="flex items-center justify-between bg-[#FFFBF5] rounded-xl p-3">
                          <span className="text-sm font-semibold text-[#2D3436]">Non-Members</span>
                          <span className="text-lg font-bold" style={{ fontFamily: 'Fredoka, cursive', color }}>{party.non_member_price}</span>
                        </div>
                      </div>

                      {/* CTA */}
                      <a
                        href="https://dynamogymnastics.co.uk/parties"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-full block text-center py-3 rounded-full font-bold text-white transition-colors flex items-center justify-center gap-2"
                        style={{ fontFamily: 'Fredoka, cursive', backgroundColor: color }}
                        data-testid={`party-book-${party.id || i}`}
                      >
                        Find Out More / Book
                        <ExternalLink className="w-4 h-4" />
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-12 md:py-16 bg-gradient-to-r from-[#ff3131] to-[#ff6b6b] text-white">
          <div className="container-gymtots text-center">
            <h2 
              className="text-2xl md:text-3xl font-bold mb-4"
              style={{ fontFamily: 'Fredoka, cursive' }}
            >
              Got Questions?
            </h2>
            <p className="mb-6 opacity-90">
              Give us a call to find out more about our birthday party packages.
            </p>
            <a
              href="tel:02380455007"
              className="inline-flex items-center gap-2 bg-white text-[#ff3131] px-8 py-4 rounded-full font-bold text-lg transition-transform hover:scale-105"
              style={{ fontFamily: 'Fredoka, cursive' }}
            >
              <Phone className="w-5 h-5" />
              Call 02380 455007
            </a>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default BirthdayPartiesPage;
